import { render, staticRenderFns } from "./OrganisationsView.vue?vue&type=template&id=7da5b6c0&scoped=true&"
import script from "./OrganisationsView.vue?vue&type=script&lang=js&"
export * from "./OrganisationsView.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationsView.vue?vue&type=style&index=0&id=7da5b6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da5b6c0",
  null
  
)

export default component.exports